import { EmptyData, NavMenuError } from 'shared/ui';
import { SectionMenu } from 'shared/ui/section-menu';

import { SECTION } from 'entities/navigation';
import { useGetDiscountsQuery } from 'entities/discount';
import { DISCOUNTS_ROUTES } from 'shared/consts/routes/discount';

const { label, path } = SECTION['discounts'];

export function ConnectedDiscountsMenu() {
  const { data, isFetching, error } = useGetDiscountsQuery();

  if (data && data.statusCode !== 0) {
    return <NavMenuError text={data.statusDescription} />;
  }

  if (error) {
    return <NavMenuError />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  const items = data?.discounts || [];

  return (
    <SectionMenu
      loading={isFetching}
      items={items}
      menuKey={path}
      absolutePath={DISCOUNTS_ROUTES.DISCOUNTS}
      label={label}
    />
  );
}
